import { exam_editExamination_Api } from 'apis'
import { getId } from 'apis/model/base'
import _ from 'lodash'
import React, { useContext, useMemo } from 'react'
import CustomRichEditor from 'views/AppLocals/custom/CustomRichEditor'
import ExaminationContext from 'views/AppLocals/Exam/ExaminationContext'
import createEditableForm from 'views/AppLocals/factory/createEditableForm'
import { bindQueryParam } from 'views/AppLocals/functions/routerHelper'
import { convertFromString, convertToString } from 'views/SlateEditor/functions'

const formFields = [{ name: 'about' }]

const formSchema = [
  {
    title: 'about examination',
    children: [
      {
        name: 'about',
        component: ({ name, value, form, onChange }) => {
          const { resetKey } = form?.values ?? {}
          return (
            <CustomRichEditor
              {...{
                name,
                value,
                resetKey,
                onChange,
              }}
              placeholder="about examination"
            />
          )
        },
      },
    ],
  },
]

const ExaminationSettingAbout = () => {
  const { examination } = useContext(ExaminationContext)

  const id = getId(examination)

  const validationSchema = undefined

  const content = useMemo(() => {
    if (_.isEmpty(examination)) return null

    return createEditableForm(
      formFields,
      formSchema
    )({
      validationSchema,
      item: examination,
      query: bindQueryParam({
        id,
      }),
      apiInfo: exam_editExamination_Api,
      initialized: ({ about, ...rest }) => ({
        ...rest,
        about: convertFromString(about),
      }),
      onPreSubmit: ({ about, resetKey, ...rest }) => ({
        ...rest,
        about: about ? convertToString(about) : undefined,
      }),
    })
  }, [examination])

  return content
}

export default ExaminationSettingAbout
